module.exports = __webpack_public_path__ + "static/Thumb_NC1_Room_comp-ce4596159600b5f031dab2a4c93f29b6.png";